import { useMutation } from "@apollo/client";
import { Card, Collapse, Grid, Icon } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import logo from "assets/images/comedor.png";
import InstallPWA from "components/InstallButton";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import routes from "routes";
import { login } from "services/login";
import { getUproColor } from "utils/colors";
import ModalCambiarPass from "../ModalCambiarPass";
import ModalActualizarPassword from "../actualizar-password";
import ModalNuevaPass from "../ModalNuevaPass";
import ModalRecuperarPass from "../recuperarPass";
import { RUTA_VENTA_EVENTO, esVendedorSoloVentaEvento } from "utils/accesoRutas";

function FixedShapesBackground() {
  const canvasRef = useRef(null);
  const shapesRef = useRef([]);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let w = (canvas.width = window.innerWidth);
    let h = (canvas.height = window.innerHeight);
    let animationFrameId;

    const defineShapes = (currentW, currentH) => [
      {
        type: "circle",
        color: "#67C1B8",
        x: currentW * 0.15,
        y: currentH * 0.2,
        size: Math.min(currentW, currentH) * 0.15,
        angle: Math.PI / 6,
        animOffset: Math.random() * 10,
        animSpeed: 0.0005,
        animMagnitude: Math.min(currentW, currentH) * 0.015,
      },
      {
        type: "donut",
        color: "#F59B24",
        x: currentW * 0.8,
        y: currentH * 0.3,
        size: Math.min(currentW, currentH) * 0.22,
        angle: -Math.PI / 4,
        animOffset: Math.random() * 10,
        animSpeed: 0.0006,
        animMagnitude: Math.min(currentW, currentH) * 0.01,
      },
      {
        type: "donut",
        color: "#F59B24",
        x: currentW * 0,
        y: currentH * 0.12,
        size: Math.min(currentW, currentH) * 0.22,
        angle: -Math.PI / 4,
        animOffset: Math.random() * 10,
        animSpeed: 0.0006,
        animMagnitude: Math.min(currentW, currentH) * 0.01,
      },
      {
        type: "donut",
        color: "#F59B24",
        x: currentW * 0.23,
        y: currentH * 1,
        size: Math.min(currentW, currentH) * 0.22,
        angle: -Math.PI / 4,
        animOffset: Math.random() * 10,
        animSpeed: 0.0006,
        animMagnitude: Math.min(currentW, currentH) * 0.01,
      },
      {
        type: "x",
        color: "#ffffff",
        x: currentW * 0.75,
        y: currentH * 0.8,
        size: Math.min(currentW, currentH) * 0.13,
        angle: 0,
        animOffset: Math.random() * 10,
        animSpeed: 0.001,
        animMagnitude: Math.min(currentW, currentH) * 0.006,
      },
      {
        type: "x",
        color: "#ffffff",
        x: currentW * 0.13,
        y: currentH * 0.9,
        size: Math.min(currentW, currentH) * 0.05,
        angle: 130 * (Math.PI / 180),
        animOffset: Math.random() * 10,
        animSpeed: 0.001,
        animMagnitude: Math.min(currentW, currentH) * 0.006,
      },
      {
        type: "x",
        color: "#ffffff",
        x: currentW * 0.19,
        y: currentH * 0.23,
        size: Math.min(currentW, currentH) * 0.04,
        angle: 45 * (Math.PI / 180),
        animOffset: Math.random() * 10,
        animSpeed: 0.001,
        animMagnitude: Math.min(currentW, currentH) * 0.006,
      },
      {
        type: "circle",
        color: "#67C1B8",
        x: currentW * 1,
        y: currentH * 0.1,
        size: Math.min(currentW, currentH) * 0.16,
        angle: 0,
        animOffset: Math.random() * 10,
        animSpeed: 0.0007,
        animMagnitude: Math.min(currentW, currentH) * 0.006,
      },
      {
        type: "circle",
        color: "#67C1B8",
        x: currentW * 0,
        y: currentH * 1,
        size: Math.min(currentW, currentH) * 0.35,
        angle: 0,
        animOffset: Math.random() * 20,
        animSpeed: 0.001,
        animMagnitude: Math.min(currentW, currentH) * 0.006,
      },
      {
        type: "donut",
        color: "#F59B24",
        x: currentW * 0.5,
        y: currentH * 0.1,
        size: Math.min(currentW, currentH) * 0.09,
        angle: Math.PI / 3,
        animOffset: Math.random() * 10,
        animSpeed: 0.0005,
        animMagnitude: Math.min(currentW, currentH) * 0.005,
      },
      {
        type: "donut",
        color: "#F59B24",
        x: currentW * 1,
        y: currentH * 1,
        size: Math.min(currentW, currentH) * 0.5,
        angle: Math.PI / 3,
        animOffset: Math.random() * 10,
        animSpeed: 0.0015,
        animMagnitude: Math.min(currentW, currentH) * 0.005,
      },
    ];

    shapesRef.current = defineShapes(w, h);

    const animate = (time) => {
      ctx.clearRect(0, 0, w, h);

      shapesRef.current.forEach((s) => {
        const currentY = s.y + Math.sin(time * s.animSpeed + s.animOffset) * s.animMagnitude;

        // Animación de shake para 'x'
        const angleShake =
          s.type === "x" ? Math.sin(time * s.animSpeed * 2 + s.animOffset) * (Math.PI / 32) : 0;

        ctx.save();
        ctx.translate(s.x, currentY);
        ctx.rotate(s.angle + angleShake);
        ctx.strokeStyle = s.color;
        ctx.fillStyle = s.color;
        ctx.lineWidth = Math.max(3, s.size / 25);
        ctx.globalAlpha = 1;

        switch (s.type) {
          case "circle":
            ctx.beginPath();
            ctx.arc(0, 0, s.size / 2, 0, 2 * Math.PI);
            ctx.fill();
            break;
          case "donut":
            const outerRadius = s.size / 2;
            const innerRadius = s.size / 4;
            ctx.beginPath();
            ctx.arc(0, 0, outerRadius, 0, 2 * Math.PI);
            ctx.fill();
            if (innerRadius > 0) {
              ctx.globalCompositeOperation = "destination-out";
              ctx.beginPath();
              ctx.arc(0, 0, innerRadius, 0, Math.PI * 2);
              ctx.fill();
              ctx.globalCompositeOperation = "source-over";
            }
            break;
          case "x":
            const maxLength = s.size / Math.SQRT2;
            const currentLength = maxLength / 2;
            ctx.beginPath();
            ctx.moveTo(-currentLength, -currentLength);
            ctx.lineTo(currentLength, currentLength);
            ctx.moveTo(currentLength, -currentLength);
            ctx.lineTo(-currentLength, currentLength);
            ctx.stroke();
            break;
        }

        ctx.restore();
      });

      animationFrameId = requestAnimationFrame(animate);
    };

    animationFrameId = requestAnimationFrame(animate);

    const handleResize = () => {
      w = canvas.width = window.innerWidth;
      h = canvas.height = window.innerHeight;
      shapesRef.current = defineShapes(w, h);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 0,
        pointerEvents: "none",
      }}
    />
  );
}

function SignIn() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [emptyFields, setEmptyFields] = useState(false);
  const [openRecuperarPass, setOpenRecuperarPass] = useState(false);
  const [errorLogin, setErrorLogin] = useState(null);
  const [openCambiarPass, setOpenCambiarPass] = useState(false);
  const [cambioPendiente, setCambioPendiente] = useState(null);
  const [recoveryData, setRecoveryData] = useState(null);
  const [openNuevaPass, setOpenNuevaPass] = useState(false);
  const [loginUser, { data, loading, error }] = useMutation(login);
  const [location, setLocation] = useState({
    latitude: null,
    longitude: null,
    accuracy: null,
  });

  const handleChanges = (event) => {
    const { name, value } = event.target;
    if (name === "username") setUsername(value);
    if (name === "password") setPassword(value);
  };

  const finalizarLogin = (loginData) => {
    const history = JSON.parse(localStorage.getItem("history"));

    if (loginData?.user?.tempPassword) {
      setOpenCambiarPass(true);
      return;
    }

    let rutasPrivadas = routes.filter((route) => route.permiso);
    let rutasPermitidas = rutasPrivadas.filter((route) =>
      loginData?.user?.permisos?.find((item) => item?.pantalla === route.permiso)
    );
    localStorage.setItem("user", JSON.stringify({ token: loginData?.token }));
    localStorage.removeItem("history");
    if (history && history.includes("/nodos/")) {
      window.location.href = history;
      return;
    }
    if (history && history.includes("/recepcion/")) {
      window.location.href = history;
      return;
    }
    if (loginData?.user?.tipoUser === "Administrador") {
      window.location.href = "/usuarios";
      return;
    }
    // Vendedor dedicado (solo el permiso 71), cualquiera sea su tipo de usuario.
    if (esVendedorSoloVentaEvento(loginData?.user)) {
      window.location.href = RUTA_VENTA_EVENTO;
      return;
    }
    if (["Convenio", "ALUMNO", "DOCENTE", "PERSONALAPOYO"].includes(loginData?.user?.tipoUser)) {
      window.location.href = "/comedorAlumnos";
      return;
    }
    if (rutasPermitidas.length > 0) {
      window.location.href = rutasPermitidas[0].route;
      return;
    } else {
      window.location.href = "/usuarios";
      return;
    }
  };

  const handleLogin = (event) => {
    event.preventDefault();
    setErrorLogin(null);
    if (username !== "" && password !== "") {
      setEmptyFields(false);
      loginUser({
        variables: {
          userInput: {
            username: username,
            passwordPlain: password,
          },
          latitud: location.latitude,
          longitud: location.longitude,
          accuracy: location.accuracy,
        },
      })
        .then((result) => {
          if (result?.data?.login !== null) {
            const loginData = result?.data?.login;

            if (loginData?.requiereCambioPassword) {
              setCambioPendiente({
                cambioToken: loginData.cambioToken,
                emailEnmascarado: loginData.emailEnmascarado,
              });
              return;
            }

            finalizarLogin(loginData);
          }
        })
        .catch((error) => {
          if (error?.message === "Failed to fetch") {
            setErrorLogin("No se pudo conectar con el servidor");
          } else {
            const errorMessage = Array.isArray(error?.networkError?.result?.errors)
              ? error?.networkError?.result?.errors[0]?.message
              : error?.message;
            setErrorLogin(errorMessage);
          }
        });
    } else {
      setEmptyFields(true);
    }
  };
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude, accuracy } = position.coords;
        setLocation({ latitude, longitude, accuracy });
      },
      () => {
        console.error("No se pudo obtener la ubicación");
      }
    );
  }, []);

  return (
    <SoftBox
      sx={{
        userSelect: "none",
        position: "relative",
        overflow: "hidden",
        height: "100vh",
        backgroundColor: getUproColor("uproPink"),
      }}
    >
      <FixedShapesBackground />

      <SoftBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%"
        sx={{ position: "relative", zIndex: 1, p: { xs: 3, md: 4 } }}
      >
        <Grid container spacing={2} justifyContent="center" alignItems="center">
          <Grid item xs={12} md={6} lg={4}>
            <Card>
              <SoftBox p={3} display="flex" flexDirection="column" justifyContent="center" gap={2}>
                <SoftBox display="flex" flexDirection="column" alignItems="center" gap={1}>
                  <SoftBox component="img" src={logo} alt="UPrO Logo" width="50%" />

                  <SoftTypography variant="h6" fontWeight="regular" textAlign="center">
                    Inicia sesión para continuar
                  </SoftTypography>
                </SoftBox>
                <SoftInput
                  type="text"
                  placeholder="Usuario"
                  name="username"
                  value={username}
                  onChange={handleChanges}
                  error={data && data.authenticateUser === null}
                  autoComplete="username"
                  icon={{
                    component: (
                      <Icon
                        sx={{
                          color: getUproColor("uproGreen"),
                        }}
                      >
                        person
                      </Icon>
                    ),
                    direction: "left",
                  }}
                />
                <SoftInput
                  type={showPassword ? "text" : "password"}
                  placeholder="Contraseña"
                  name="password"
                  value={password}
                  onChange={handleChanges}
                  error={data && data.authenticateUser === null}
                  autoComplete="current-password"
                  sx={{ flex: 1 }}
                  icon={{
                    component: (
                      <Icon
                        sx={{
                          color: getUproColor("uproGreen"),
                        }}
                      >
                        key
                      </Icon>
                    ),
                    direction: "left",
                  }}
                  icon2={{
                    component: (
                      <Icon color="primary" onClick={() => setShowPassword(!showPassword)}>
                        {showPassword ? "visibility" : "visibility_off"}
                      </Icon>
                    ),
                    direction: "right",
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleLogin(e);
                    }
                  }}
                />
                <SoftButton type="submit" color="primary" fullWidth circular onClick={handleLogin}>
                  {loading ? <CircularProgress color="inherit" size={17} /> : "Iniciar sesión"}
                </SoftButton>
                <SoftButton
                  component={Link}
                  to={"/formulario"}
                  color="uproYellow"
                  fullWidth
                  circular
                >
                  Registrate como usuario &nbsp;
                  <Icon sx={{ fontWeight: "light" }}>arrow_forward</Icon>
                </SoftButton>
                <SoftButton
                  component={Link}
                  to={"/proveedores"}
                  color="uproGreen"
                  fullWidth
                  circular
                >
                  Acceso proveedores &nbsp;
                  <Icon sx={{ fontWeight: "light" }}>arrow_forward</Icon>
                </SoftButton>

                <Collapse
                  in={
                    (error && errorLogin) ||
                    (errorLogin && error === undefined) ||
                    (emptyFields && error === undefined)
                  }
                  mountOnEnter
                  unmountOnExit
                >
                  <SoftBox display="flex" justifyContent="center" alignItems="center">
                    {emptyFields && (
                      <SoftTypography variant="caption" color="error">
                        Debes ingresar un usuario y contraseña
                      </SoftTypography>
                    )}
                    {!emptyFields && error && (
                      <SoftTypography variant="caption" color="error">
                        {errorLogin}
                      </SoftTypography>
                    )}
                    {!emptyFields && errorLogin && error === undefined && (
                      <SoftTypography variant="caption" color="error">
                        {errorLogin}
                      </SoftTypography>
                    )}
                  </SoftBox>
                </Collapse>
                <SoftButton
                  variant="text"
                  color="uproYellow"
                  fullWidth
                  circular
                  onClick={() => setOpenRecuperarPass(true)}
                >
                  Recuperar contraseña &nbsp;
                  <Icon sx={{ fontWeight: "light" }}>help</Icon>
                </SoftButton>
              </SoftBox>
            </Card>
          </Grid>
        </Grid>
        <SoftBox
          sx={{
            position: "absolute",
            bottom: 20,
            left: { xs: 0, sm: "auto" },
            right: { xs: 0, sm: 20 },
            width: { xs: "100%", sm: "auto" },
            display: "flex",
            justifyContent: { xs: "center", sm: "flex-end" },
            px: { xs: 2, sm: 0 },
          }}
        >
          <InstallPWA />
        </SoftBox>
      </SoftBox>
      <ModalCambiarPass
        open={openCambiarPass}
        handleClose={() => setOpenCambiarPass(false)}
        data={data}
      />
      <ModalNuevaPass
        open={openNuevaPass}
        handleClose={() => setOpenNuevaPass(false)}
        idUser={recoveryData?.idUser}
        codigo={recoveryData?.codigo}
      />
      <ModalRecuperarPass
        open={openRecuperarPass}
        handleClose={() => setOpenRecuperarPass(false)}
        username={username}
        handleChangePass={(response) => {
          setRecoveryData(response);
          setOpenRecuperarPass(false);
          setOpenNuevaPass(true);
        }}
      />
      <ModalActualizarPassword
        open={Boolean(cambioPendiente)}
        cambioToken={cambioPendiente?.cambioToken}
        emailEnmascarado={cambioPendiente?.emailEnmascarado}
        onCancel={() => setCambioPendiente(null)}
        onSuccess={(loginData) => {
          setCambioPendiente(null);
          finalizarLogin(loginData);
        }}
      />
    </SoftBox>
  );
}

export default SignIn;
